module.exports = __webpack_public_path__ + "media/vo-01-02.2d71b3d1.mp3";